import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import c from '../constant';

function LabelDetail({
	label = null,
	titleDetail = null,
	childDetail = null,
	mt = '2px',
	mb = '4px',
	direction = 'column',
	labelWidth = '',
	hoverBgColor = 'gray.100',
	responsive = false,
	...props
}) {
	const { t } = useTranslation();

	return (
		<Flex _hover={{ bg: hoverBgColor }} flex={1} direction="column" borderRadius={c.borderRadius} key={props?.key} mt={mt} mb={mb}>
			<Flex direction={responsive ? { base: 'column', sm: 'center', md: direction } : direction}>
				{label && (
					<Flex
						mr={4}
						w={responsive ? { base: '100%', sm: '100%', md: labelWidth } : labelWidth}
						minW={responsive ? { base: '100%', sm: '100%', md: labelWidth } : labelWidth}
						maxW={responsive ? { base: '100%', sm: '100%', md: labelWidth } : labelWidth}
						alignItems="center"
						justifyContent={responsive ? { base: 'center', sm: 'center', md: 'flex-start' } : 'flex-start'}
						textAlign={responsive ? { base: 'center', sm: 'center', md: 'start' } : 'start'}
					>
						<Text fontWeight="600" color="#303030" w="100%" textAlign={responsive ? { base: 'center', sm: 'center', md: 'start' } : 'start'}>
							{t(label)}
						</Text>
					</Flex>
				)}
				<Flex
					w="100%"
					direction="column"
					justifyContent="center"
					alignItems={responsive ? { base: 'center', sm: 'center', md: 'flex-start' } : 'flex-start'}
					mt={0}
				>
					{titleDetail ? (
						<Text w="100%" fontWeight="normal" color="#303030" textAlign={responsive ? { base: 'center', sm: 'center', md: 'start' } : 'start'}>
							{t(titleDetail)}
						</Text>
					) : (
						<Flex
							w="100%"
							justifyContent={responsive ? { base: 'center', sm: 'center', md: 'flex-start' } : 'flex-start'}
							textAlign={responsive ? { base: 'center', sm: 'center', md: 'start' } : 'start'}
						>
							{childDetail}
						</Flex>
					)}
				</Flex>
			</Flex>
		</Flex>
	);
}

export default LabelDetail;
